import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
// import {Row, Col, Image} from 'react-bootstrap';
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import DjangoIcon from "../../images/tech_stack/django-icon.png";
import ReactIcon from "../../images/tech_stack/react-icon.png";
import PipelineIcon from "../../images/tech_stack/pipeline-icon.svg";
import PythonIcon from "../../images/tech_stack/python-icon.png";
import SGIcon from "../../images/tech_stack/sg-icon.png";
import APIIcon from "../../images/tech_stack/api-icon.png";
import AWSIcon from "../../images/tech_stack/aws-icon.png";

import AutodeskIcon from "../../images/tech_stack/autodesk-icon.png";

import defaultCardImage from "../../images/shield-icon.svg";

const Container = tw.div`relative -mx-8 px-8 bg-gray-800 text-gray-100`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24 `}
`;

const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center text-gray-200`;

const VerticalSpacer = tw.div`mt-10 w-full`

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col bg-gray-200 sm:flex-row items-center sm:items-start text-center sm:text-left h-128 mx-2 my-2 px-2 py-4 rounded-lg shadow-lg `}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0 `}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:mx-4 sm:my-4 w-full`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl text-black leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-gray-700 leading-loose`}
  }
`;

const CardType = tw.div`font-semibold text-sm text-gray-500 `;

export default ({ cards = null, 
  heading = (
  <>
  <span tw="text-primary-500">Tech</span> Stack
</>  ),
  subheading = "Tools I work with",
  description = "Technologies and platforms I use to build production tools, integrations and web applications." }) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) title - the title of the card
   *  2) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const defaultCards = [
    {
      image: DjangoIcon,
      title: "Django REST",
      type: "Backend & API Architecture",
      description: "DRF services, class-based views, serialization and PostgreSQL-backed APIs designed for security, performance and scale."
    },
    { 
      image: PythonIcon,
      title: "Python",
      type: "Pipeline & Backend Engineering",
      description: "Python powers pipeline tooling, automation, APIs and connections between existing production systems."
    },
    { 
      type: "Frontend Collaboration",
      image: ReactIcon,
      title: "React",
      description: "API contracts, state-driven interfaces and close collaboration with frontend teams to deliver reliable end-to-end features."
    },
    { 
      type: "Production Tracking",
      image: SGIcon,      
      title: "ShotGrid",
      description: "API integrations, Action Menu Items and workflow automation connecting production tracking with DCCs, storage and delivery systems."
    },
    { 
      type: "API Design & Documentation",
      image: APIIcon,
      title: "OpenAPI & REST",
      description: "RESTful API architecture, OpenAPI specifications and clear service contracts that improve integration and developer experience."
    },
    { 
      type: "Production Tooling",
      image:AutodeskIcon,
      title: "DCC Integration",
      description: "Custom tools and integrations across Nuke, Maya, 3ds Max, RV, Rez and ShotGrid for connected production workflows."
    },
    { 
      type: "Cloud & Delivery Automation",
      image:AWSIcon,
      title: "AWS & CI",
      description: "SQS, SNS, Terraform, automated testing and GitHub Actions supporting asynchronous processing and dependable delivery."
    },
    { 
      type: "Event-Driven Workflows",
      image:PipelineIcon,
      title: "Production Systems",
      description: "Render, media-processing, file-transfer and messaging systems built around Deadline, Mattermost and production events."
    },    
    // { 
    //   title: "Javascript",
    //   description: "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."
    // },
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container id="tech">
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="textContainer">
                  <CardType>{card.type}</CardType>
                <img src={card.image || defaultCardImage} tw="items-center m-auto my-8" width={128} height={128} alt=""></img>
                <span className="title">{card.title || ""}</span>
                <p className="description">
                  {card.description || "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
    </Container>
  );
};
